import routes from '@/Router/routes.constants'

export const steps = {
  exchange: {
    withRefund: [
      routes.productSelectionPage,
      routes.deliveryMethodsPage,
      routes.refundSelectionPage,
      routes.summaryPage,
    ],
    withoutRefund: [routes.productSelectionPage, routes.deliveryMethodsPage, routes.summaryPage],
  },
  refund: [routes.productSelectionPage, routes.deliveryMethodsPage, routes.refundSelectionPage, routes.summaryPage],
  cancellations: [routes.productSelectionPage, routes.refundSelectionPage, routes.summaryPage],
}
